import { useCallback, useEffect, useRef, useState } from 'react';
import Form from 'devextreme-react/form';
import { useParams } from 'react-router';
import { ButtonType } from 'devextreme-react/common';
import 'devextreme-react/autocomplete';
import 'devextreme-react/date-range-box';
import { accountService } from '@/core/services/account-service';
import { IAccount } from '@/core/interfaces/usestate-interfaces';

import { useNavigate } from 'react-router-dom';
import { t } from 'i18next';
import { ScrollView } from 'devextreme-react';
import { ELEMENT_ID } from '@/core/constants/common/element-constants';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import { Config } from '@/core/config/config';
import DataSource from 'devextreme/data/data_source';
import { httpHeaderHelper } from '@/core/helper/http-header';
import FormWrapper from '@/core/wrappers/form-wrapper';
import { BUTTON_CONSTANTS } from '@/core/constants/common/button-contants';
import CustomStore from 'devextreme/data/custom_store';

function AccountDefinition(props: any) {
    const { accountId } = props;
    const formRef: any = useRef<Form>();
    const [account, setAccount] = useState<IAccount>({ id: '', name: '', parentId: '' });
    const [parameters, setParameters] = useState([]);
    const [accounts, setAccounts] = useState<DataSource | null>(null);
    const params = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        if (accountId && account.id == '') {
            (async function () {
                const getAccount = await accountService.getAccount(accountId)
                const data = getAccount.data;
                setAccount({ id: data.id, name: data.name, parentId: data.parentId })
            })();
        }
    }, [account]);

    useEffect(() => {
        const fetchParentAccounts = async () => {
            const store = new CustomStore({
                key: 'id',
                load: accountService.lookupAccounts,
                byKey: async (key, loadOptions: any) => {
                    var returnObject = null;
                    if (key) {
                        loadOptions.filter = ["Id", "=", key];
                        const objectsByID = (await accountService.lookupAccounts(loadOptions))
                        returnObject = objectsByID.data.length > 0 ? objectsByID.data[0] : null;
                    }
                    return returnObject
                },
                useDefaultSearch: true
            });
            const dataSource = new DataSource(store);
            setAccounts(dataSource);
        }
        fetchParentAccounts();
    }, []);


    const handleSubmit = useCallback(async (): Promise<void> => {
        return new Promise(async (resolve, reject) => {
            try {
                const accountForm = formRef.current.props.formData;
                if (accountId) {
                    await accountService.updateAccount(null, accountForm)
                } else {
                    await accountService.createAccount(accountForm)
                    navigate(`/account-list`)
                }
                resolve();
            } catch (error) {
                reject(error)
            }

        })
    }, []);


    const accountNameEditorOptions = {
        inputAttr: { [ELEMENT_ID]: 'accountName' },
    };


    const parentAccountEditorOptions = {
        inputAttr: { [ELEMENT_ID]: 'parentId' },
        dataSource: accounts,
        displayExpr: 'name',
        valueExpr: 'id',
        placeholder: undefined,
    };
    return (
        <ScrollView>
            <FormWrapper
                onSubmit={handleSubmit}
                formRef={formRef}
                formData={account}
                backButtonNavigationPath='/account-list'
                isAddBackBtn={true}
                buttonGroups={[
                    { buttonOptions: BUTTON_CONSTANTS.SaveBtn }
                ]}
                simpleItemGroups={[
                    {
                        caption: account.id == '' ? t('new_account') : t('edit_account'),
                        useColCountByScreen: true,
                        items: [
                            {
                                dataField: 'name',
                                editorType: 'dxTextBox',
                                editorOptions: accountNameEditorOptions,
                                label: 'account_name',
                                isRequired: true,
                                requiredMessage: 'account_name_required'
                            },
                            {
                                dataField: 'parentId',
                                editorType: 'dxSelectBox',
                                editorOptions: parentAccountEditorOptions,
                                label: 'parent_account',
                                isRequired: false
                            }
                        ]
                    }
                ]}

            />
        </ScrollView>
    );
}
export default AccountDefinition;